export const transferStates={processing:'İşleniyor',failed:'Tamamlanamadı',completed:'Tamamlandı'};
export const transferError=error=>{
  const value=error.response?.data?.detail;
  if(typeof value==='string')return value;
  if(value?.message)return value.message;
  if(Array.isArray(value))return 'Alanları kontrol edin. Tutar pozitif ve en fazla iki ondalık basamaklı olmalı.';
  return 'İşlem sonucu doğrulanamadı. Transfer geçmişini kontrol edin; aynı işlemi yeniden deneyebilirsiniz.';
};